import template from './in-house-rent.jade';
import inHouseRentAdditional from '../../../enums/in-house-rent-additional';

export default angular.module('cian.addForm.inHouseRent', []).directive('cianAfAboutObjectInHouseRent', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    function () {
      this.checkboxes = inHouseRentAdditional;
    },
  ],
  controllerAs: 'inHouseRent',
  template,
})).name;
